import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { colors, gradients } from '../styles/design-tokens';

const navLinks = [
  { path: '/features', label: 'Features' },
  { path: '/compatibility', label: 'Compatibility' },
  { path: '/about', label: 'About' },
  { path: '/contact', label: 'Contact' },
];

export default function Navbar() {
  const { user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header
      className="sticky top-0 z-50 backdrop-blur-md"
      style={{ background: 'rgba(10, 22, 40, 0.85)', borderBottom: `1px solid ${colors.border}` }}
    >
      <nav className="container mx-auto px-4 py-4 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3">
          <img src="/assets/icon.svg" alt="NorthStar Aurora" className="h-9 w-9" />
          <div>
            <div className="text-lg font-semibold leading-tight" style={{ color: colors.cream }}>NorthStar</div>
            <div className="text-xs leading-tight" style={{ color: colors.gold }}>Aurora Pixel Engine</div>
          </div>
        </Link>

        {/* Desktop nav */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map(({ path, label }) => (
            <Link
              key={path}
              to={path}
              className="text-sm font-medium transition hover:opacity-100"
              style={{
                color: location.pathname === path ? colors.gold : colors.textSecondary,
                opacity: location.pathname === path ? 1 : 0.8,
              }}
            >
              {label}
            </Link>
          ))}
          {user ? (
            <button
              onClick={() => navigate('/dashboard')}
              className="px-5 py-2 rounded-lg text-sm font-semibold transition hover:opacity-90"
              style={{ background: gradients.goldButton, color: colors.navy }}
            >
              Dashboard
            </button>
          ) : (
            <Link
              to="/waitlist"
              className="px-5 py-2 rounded-lg text-sm font-semibold transition hover:opacity-90"
              style={{ background: gradients.goldButton, color: colors.navy }}
            >
              Join Waitlist
            </Link>
          )}
        </div>

        {/* Mobile hamburger */}
        <button
          className="md:hidden p-2"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={colors.cream} strokeWidth="2">
            {mobileOpen ? (
              <path d="M6 6l12 12M6 18L18 6" />
            ) : (
              <path d="M3 6h18M3 12h18M3 18h18" />
            )}
          </svg>
        </button>
      </nav>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="md:hidden px-4 pb-4 space-y-3" style={{ borderTop: `1px solid ${colors.border}` }}>
          {navLinks.map(({ path, label }) => (
            <Link
              key={path}
              to={path}
              onClick={() => setMobileOpen(false)}
              className="block py-2 text-sm font-medium"
              style={{ color: location.pathname === path ? colors.gold : colors.textSecondary }}
            >
              {label}
            </Link>
          ))}
          {user ? (
            <button
              onClick={() => { navigate('/dashboard'); setMobileOpen(false); }}
              className="w-full py-2 rounded-lg text-sm font-semibold"
              style={{ background: gradients.goldButton, color: colors.navy }}
            >
              Dashboard
            </button>
          ) : (
            <Link
              to="/waitlist"
              onClick={() => setMobileOpen(false)}
              className="block text-center py-2 rounded-lg text-sm font-semibold"
              style={{ background: gradients.goldButton, color: colors.navy }}
            >
              Join Waitlist
            </Link>
          )}
        </div>
      )}
    </header>
  );
}
